import React from 'react';
import { cn } from './cn';

const PADDING = {
  none: '',
  sm: 'p-3',
  md: 'p-4 md:p-6',
  lg: 'p-6 md:p-8',
};

export default function Card({ className, padding = 'md', as: Component = 'div', ...props }) {
  return (
    <Component
      className={cn(
        'rounded-ga-md border border-ga-border-subtle bg-ga-bg-surface text-ga-text-primary shadow-ga-soft',
        PADDING[padding] ?? PADDING.md,
        className
      )}
      {...props}
    />
  );
}
